export default function Footer(){

return(

<footer
style={{
marginTop:"60px",
padding:"20px",
textAlign:"center",
borderTop:"1px solid #e5e7eb",
color:"#6b7280",
fontSize:"14px"
}}
>

© 2026 SamType • Built by Samir

</footer>

)

}